<template>
  <el-dialog
    title="使用兑换码"
    v-model="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div class="pay-result" v-if="codeResult">
      <p class="success" v-if="codeResult == true">兑换成功</p>
      <p class="fail" v-else>{{ codeResult }}</p>
    </div>
    <el-form
      ref="codeFormRef"
      style="max-width: 600px"
      :model="codeForm"
      :rules="rules"
      label-width="80px"
      class="code-form"
      @submit.prevent="submitForm(codeFormRef)"
      v-else
    >
      <el-form-item label="兑换码" prop="code">
        <el-input v-model="codeForm.code" />
      </el-form-item>
      <el-form-item label="">
        <el-button type="default" @click="submitForm(codeFormRef)">兑换</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script lang="ts" setup>
import { reactive, ref } from 'vue'
import { useCode } from '@/api/product'
import { ElMessage } from 'element-plus'

const dialogVisible = ref(false)

const codeFormRef = ref(null)
const codeForm = reactive({
  code: '',
})

const codeResult = ref(null)
const apiErrorMessage = ref('')
const rules = reactive({
  code: [{ required: true, message: '请输入激活码', trigger: 'blur' }],
})

const submitForm = async (formEl) => {
  if (!formEl) return
  formEl.clearValidate()
  await formEl.validate(async (valid, fields) => {
    if (valid) {
      let res = await useCode({ code: codeForm.code })
      if (res.data.ret == 0) {
        codeResult.value = true
        setTimeout(() => {
          dialogVisible.value = false
        }, 3000)
      } else {
        // 通过表单校验显示错误信息 res.data.msg
        // formEl.setFieldError('code', res.data.msg)
        // apiErrorMessage.value = res.data.msg
        // setTimeout(() => {
        //   formEl.validateField('code')
        // }, 0)
        ElMessage.error(res.data.msg)
      }
    } else {
      console.log('error submit!', fields)
    }
  })
}

function showDialog() {
  codeForm.code = ''
  codeResult.value = null
  dialogVisible.value = true
}
defineExpose({
  showDialog,
})
</script>
